export function buildPublicContactLink(code) {
    if (code != null)
    {
        return process.env.VUE_APP_URL + "customerjobs?code=" + process.env.VUE_APP_API_CODE + "&custcode=" + code;
    }
    return null;
}